<template>
    <Modal
            v-model="dialogShow"
            :title="$t('Components.picturePreviewDialog.title')"
            :mask-closable="false"
            :footer-hide="true"
            width="50%"
            style="text-align:center"
    >
        <img :src="src" :alt="$t('Components.picturePreviewDialog.alt')" onError="imgError(this)" style="max-width:100%;object-fit:scale-down">
    </Modal>
</template>

<script>
    export default {
        props: ["value", "imageSrc"],
        name: "picture-preview-dialog",
        data() {
            return {
                dialogShow: false,
                src: ""
            }
        },
        watch: {
            value() {
                this.dialogShow = this.value;
                if (this.dialogShow) {
                    this.viewPicture();
                }
            },
            dialogShow() {
                this.$emit("input", this.dialogShow);

                if (this.dialogShow) {
                    this.viewPicture();
                } else {
                    this.dialogShow = false
                }
            }
        },
        methods: {
            viewPicture(){
                this.dialogShow = true;
                this.src = this.imageSrc;
            }
        }
    }
</script>

<style scoped>

</style>